import React from 'react';
import { Select as MuiSelect, MenuItem, styled, FormControl, InputLabel } from '@mui/material';

const StyledSelect = styled(MuiSelect)(({ theme }) => ({
    '& .MuiOutlinedInput-input': {
        padding: '10px 14px',
        fontSize: '0.875rem',
    },
    '& .MuiInputLabel-outlined': {
        fontSize: '0.875rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ddd',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bbb',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#aaa',
    },
}));

export const SelectField = ({
    options,
    onChange,
    value,
    label,
    variant = 'outlined',
    size = 'small',
    ...props
}) => {
    const handleChange = (event) => {
        const newValue = event.target.value;
        onChange(newValue);
    };

    return (
        <FormControl variant={variant} size={size} fullWidth={props.fullWidth}>
            {label && <InputLabel>{label}</InputLabel>}
            <StyledSelect
                value={value}
                onChange={handleChange}
                label={label}
                {...props}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </StyledSelect>
        </FormControl>
    );
};